/** The week as the counter reads it: Monday first. Numbers are JavaScript's (Sunday is 0), like `validDays`. */
export const WEEK_ORDER: readonly number[] = [1, 2, 3, 4, 5, 6, 0];

export const DAY_SHORT = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
export const DAY_NAME = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
export const DAY_PLURAL = ['domingos', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábados'];

const DAYS_IN_WEEK = 7;

/** Keeps only real weekdays, once each, in number order: what the API stores. */
export function normalizeDays(days: readonly number[]): number[] {
  return [...new Set(days)].filter((day) => Number.isInteger(day) && day >= 0 && day < DAYS_IN_WEEK).sort((a, b) => a - b);
}

/** No day marked, or all seven, both mean "every day". */
export function isEveryDay(days: readonly number[]): boolean {
  const picked = normalizeDays(days);
  return picked.length === 0 || picked.length === DAYS_IN_WEEK;
}

export function toggleDay(days: readonly number[], day: number): number[] {
  return days.includes(day) ? days.filter((picked) => picked !== day) : normalizeDays([...days, day]);
}

/** "Solo los martes", "Solo lunes y jueves": said on the row so nobody wonders why the POS skipped it. */
export function daysSummary(days: readonly number[] | undefined): string | undefined {
  if (!days || isEveryDay(days)) return undefined;
  const names = WEEK_ORDER.filter((day) => days.includes(day)).map((day) => DAY_PLURAL[day] ?? '');
  if (names.length === 1) return `Solo los ${names[0]}`;
  return `Solo ${names.slice(0, -1).join(', ')} y ${names.at(-1)}`;
}

/** Reads `?dias=2` or `?dias=2,4` from a link; anything else is ignored. */
export function parseDaysParam(value: unknown): number[] {
  if (typeof value !== 'string' && typeof value !== 'number') return [];
  return normalizeDays(String(value).split(',').map((part) => Number(part.trim())));
}
